import { Core } from "@/core/Core";

export default {

  /* Images */

  async getImage(context, {inventoryId, imageId}) {
    try {
      return await Core.request("GET", "/api/inventory/" + inventoryId + "/images/" + imageId);
    } catch (e) {
      return null;
    }
  },

  async saveImage(context, {inventoryId, image}) {
    try {
      return await Core.request("POST", "/api/inventory/" + inventoryId + "/images", {
        name: "",
        image: image
      });
    } catch (e) {
      return null;
    }
  }

}